exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-card .card-body{padding:0;overflow:hidden}", ""]);

// exports
